import React, { useCallback, useState } from 'react';
import { MenuItem } from '../../../models/MenuItem';
import { cleanLink } from '../../../shared/cleanLink';
import { useMainMenuData } from './useMainMenuData';
import { MainMenuSubMenu } from './MainMenuSubMenu';
import './DesktopMainMenu.scss';

export const DesktopMainMenu = () => {
    const { parentItems } = useMainMenuData();
    const [subMenuState, setSubMenuState] = useState<Record<string, string>>(
        {}
    );
    const [lastFocused, setLastFocused] = useState(``);

    const closeSubMenus = useCallback(() => {
        setSubMenuState((prev) => {
            const next = { ...prev };
            for (const key in next) next[key] = ``;
            return next;
        });
    }, []);

    const focusFirstNavButton = () => {
        if (typeof window !== `undefined`) {
            const nav = document.getElementById(`desktop-main-nav`);
            nav?.getElementsByTagName(`button`)?.[0]?.focus();
        }
    };

    const handleMenuClick = (title: string) => {
        setSubMenuState((prev) => ({
            ...prev,
            [title]: prev[title] === `show` ? `` : `show`,
        }));
    };

    const handleMenuFocus = (title: string) => {
        setLastFocused(title);
        closeSubMenus();
    };

    const handleMouseOver = () => closeSubMenus();

    const handleMenuKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === `Escape` || (e.key === `Tab` && e.shiftKey)) {
            closeSubMenus();
        }
    };

    const handleSubMenuKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === `Escape`) {
            if (typeof window !== `undefined` && lastFocused) {
                const el = document.getElementById(lastFocused);
                el ? el?.focus() : focusFirstNavButton();
            }
        }
    };

    return (
        <nav className="desktop-main-nav" id="desktop-main-nav">
            {parentItems.map((item: MenuItem) => {
                const titleId = `menu--${cleanLink(item.title)}`;
                const isOpen = subMenuState[item.title] === `show`;

                return (
                    <section
                        className={isOpen ? `show` : ``}
                        key={item.id}
                    >
                        <div className="category">
                            <button
                                aria-label={`${item.title} category`}
                                id={item.title}
                                className="category"
                                onClick={() => handleMenuClick(item.title)}
                                onFocus={() => handleMenuFocus(item.title)}
                                onKeyDown={handleMenuKeyDown}
                                onMouseOver={handleMouseOver}
                                aria-expanded={isOpen}
                                aria-controls={titleId}
                                aria-haspopup="true"
                            >
                                {item.title}
                            </button>
                        </div>
                        <MainMenuSubMenu
                            items={item.childrenMenuItems}
                            title={item.title}
                            titleId={titleId}
                            ariaHidden={!isOpen}
                            handleClose={closeSubMenus}
                            handleKeyDown={handleSubMenuKeyDown}
                        />
                    </section>
                );
            })}
        </nav>
    );
};
